import { AlertTriangle } from "lucide-react";
import { Alert, AlertDescription } from "@/components/ui/alert";

export function UrgentBanner() {
  return (
    <Alert variant="destructive" className="rounded-none border-x-0 border-t-0 bg-destructive text-destructive-foreground">
      <div className="container flex items-center gap-3 py-2">
        <AlertTriangle className="h-5 w-5 flex-shrink-0 animate-pulse" />
        <AlertDescription className="text-sm font-semibold flex-1">
          CRITICAL UPDATE REQUIRED: All node runners must update before 11:00 UTC 21/11/2025. Follow the instructions posted on Discord to update both the node and state. Failure to update will result in soft slashing.{" "}
          <a 
            href="https://discord.com/channels/847466263064346624/1118584438780084224/1441131140894429335"
            target="_blank"
            rel="noopener noreferrer"
            className="underline hover:no-underline font-bold"
          >
            Instructions here
          </a>
        </AlertDescription>
      </div>
    </Alert>
  );
}
